import React from 'react';
import { Container } from 'react-bootstrap';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';

const SettingsPage = () => {
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="flex-grow-1">
                <Navbar />
                <Container fluid className="p-4">
                    <h2 className="mb-4">Settings</h2>
                    <p className="text-muted">Application settings will be implemented here.</p>
                    {/* TODO: Implement company settings, leave types, holidays configuration */}
                </Container>
            </div>
        </div>
    );
};

export default SettingsPage;
